module.exports = __webpack_public_path__ + "static/media/017.34c6ceba.jpg";